import React from "react";
import Header from "./navbar/Header";

import Footer from "./footer/Footer";

const blogs = [
  {
    id: 1,
    title: "BS4 vs BS6 : Embrace a Greener Future with Maruti Suzuki BS6 Cars",
    description:
      "As environmental concerns continue to grow, the Indian government has implemented the Bharat Stage Emission Standards (BSES) to regulate pollution emitted by vehicles. These...",
    image: "https://www.varunmaruti.com/uploads/images/blogs/1617882062101.jpg",
  },
  {
    id: 2,
    title:
      "5 Reasons That Show Why Indians Are Buying Petrol Cars Instead Of Diesel Cars",
    description:
      "Petrol cars are the new trend in AP & Telangana. In the last quarter Q2, at Varun Motors, we sold 8530 of petrol cars compared to 4248 CNG & petrol cars in 2019-20 & Zero...",
    image: "https://www.varunmaruti.com/uploads/images/blogs/161788192591.jpg",
  },
  {
    id: 3,
    title:
      "Smart Hybrid Cars: Paving the Way for a Sustainable and Economical Driving",
    description:
      "Smart Hybrid is the advanced technology in automobile engineering pioneered by Maruti Suzuki. The technology improves your car’s fuel efficiency and driving performance. The...",
    image: "https://www.varunmaruti.com/uploads/images/blogs/3rd-blog-img.jpg",
  },
];

const Blogs = () => {
  return (
    <>
      <Header />
      {/* <div className="mb-20">
        <img
          src={require("../assets/about-us_bg.jpeg")}
          className="w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]
              object-cover  object-center"
          alt="outlets"
        />
      </div> */}
      {/* <div className="shadow sm:px-0 px-4">
        <p className="mx-auto container ">
          <Link to="/">Home</Link> / Blogs
        </p>
      </div> */}
      <section className="max-w-7xl mx-auto px-5 py-16">
        {/* Heading */}
        <div className="text-center mb-12">
          <h1 className="text-3xl font-medium text-gray-800">
            Blogs – Gem Motors
          </h1>

          {/* Underline */}
          <div className="flex justify-center items-center gap-2 mt-3">
            <span className="w-[300px] h-[2px] p-0.5 rounded-lg bg-red-500"></span>
          </div>
        </div>

        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300"
            >
              {/* Image */}
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-52 object-cover rounded-t-lg"
              />

              {/* Content */}
              <div className="p-6 flex flex-col min-h-[260px]">
                <h3 className="text-lg font-semibold text-blue-900 mb-3">
                  {blog.title}
                </h3>

                <p className="text-gray-600 text-sm flex-grow">
                  {blog.description}
                </p>

                {/* Button */}
                <div className="mt-4 text-right">
                  <button className="bg-[#DC2627] text-white px-5 py-2 rounded-md text-sm hover:bg-blue-900 transition">
                    Read More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Blogs;
